export const COMPANY_NAME = "SACCCUL ONLINE"
export const COMPANY_NAME_FULL = "SACCCUL ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "SACCCUL ONLINE"
export const META_DESCRIPTION = "Welcome to SACCCUL ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.sacccul.com"
export const ENABLE_OTHER_DEPOSIT = false
